const useStyles = {
  radioGroup: {
    marginLeft: '9px',
  },
}

export default useStyles
